import React ,  { useState, useContext}from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { ModalWrapper } from './Modal';
import { PriceContext } from './context';

// --- Styled Components Definitions ---

// Global Page Container
const PageContainer = styled.div`
  position: relative;
  display: flex;
  width: 100%;
  min-height: 100vh;
  flex-direction: column;
  background-color: #131516; /* bg-[#131516] */
  justify-content: space-between;
  overflow-x: hidden;
  font-family: "Space Grotesk", "Noto Sans", sans-serif;
  color: #fff; /* Default text color as most elements are white */
`;

// Header Bar
const HeaderBar = styled.header`
  display: flex;
  align-items: center;
  background-color: #131516; /* bg-[#131516] */
  padding: 1rem 1rem 0.5rem 1rem; /* p-4 pb-2 (16px 16px 8px 16px) */
  justify-content: center; /* Changed to center content after removing arrow */
`;

/*
  Removed BackArrowIcon styled component as it's no longer needed.
*/

const HeaderTitle = styled.h2`
  color: #fff;
  font-size: 1.125rem;       /* text-lg (18px) */
  font-weight: 700;          /* font-bold */
  line-height: 1.25;         /* leading-tight */
  letter-spacing: -0.015em;  /* tracking-[-0.015em] */
  flex: 1;                   /* flex-1 */
  text-align: center;
  padding-right: 0;       /* Removed padding-right after removing arrow, now centered */
`;

// Pricing Grid
const PricingGrid = styled.div`
  display: grid;
  /* CORRECTED: Changed 'minmax(3 1fr)' to 'minmax(228px, 1fr)' */
  grid-template-columns: repeat(auto-fit, minmax(228px, 1fr));
  gap: 0.625rem; /* gap-2.5 (10px) */
  padding: 0.75rem 1rem; /* px-4 py-3 (16px horizontal, 12px vertical) */

  /* @3xl:grid-cols-4 */
  /* Tailwind's 3xl breakpoint is typically 1536px, but for general responsiveness,
     a common desktop breakpoint like 1024px or 1280px is often used if not strictly tied to Tailwind defaults.
     I'll use 1024px as a reasonable approximation. */

`;

// Individual Pricing Card
const PricingCard = styled.div`
  display: flex;
  flex: 1; /* flex-1 */
  flex-direction: column;
  gap: 1rem; /* gap-4 (16px) */
  border-radius: 0.75rem; /* rounded-xl (12px) */
  border: 1px solid #41484e; /* border border-solid border-[#41484e] */
  background-color: #1e2224; /* bg-[#1e2224] */
  padding: 1.5rem; /* p-6 (24px) */
`;

const PlanHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem; /* gap-1 (4px) */
`;

const PlanName = styled.h1`
  color: #fff;
  font-size: 1rem; /* text-base (16px) */
  font-weight: 700; /* font-bold */
  line-height: 1.25; /* leading-tight */
`;

const PlanPrice = styled.p`
  display: flex;
  align-items: baseline;
  gap: 0.25rem; /* gap-1 (4px) */
  color: #fff; /* text-white */
`;

const PriceNumber = styled.span`
  color: #fff;
  font-size: 2.25rem;         /* text-4xl (36px) */
  font-weight: 900;           /* font-black */
  line-height: 1.25;          /* leading-tight */
  letter-spacing: -0.033em;   /* tracking-[-0.033em] */
`;

const PriceFrequency = styled.span`
  color: #fff;
  font-size: 1rem; /* text-base (16px) */
  font-weight: 700; /* font-bold */
  line-height: 1.25; /* leading-tight */
`;

const SubscribeButton = styled.button`
  display: flex;
  min-width: 84px;
  max-width: 480px;
  cursor: pointer;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  border-radius: 9999px; /* rounded-full */
  height: 2.5rem; /* h-10 (40px) */
  padding: 0 1rem; /* px-4 (16px horizontal) */
  background-color: #2c3135; /* bg-[#2c3135] */
  color: #fff; /* text-white */
  font-size: 0.875rem; /* text-sm (14px) */
  font-weight: 700; /* font-bold */
  line-height: 1.5; /* leading-normal */
  letter-spacing: 0.015em; /* tracking-[0.015em] */
  border: none; /* Override default button border */

  span {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis; /* truncate */
  }
`;

const FeatureList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem; /* gap-2 (8px) */
`;

const FeatureItem = styled.div`
  font-size: 0.8125rem; /* text-[13px] (13/16 = 0.8125rem) */
  font-weight: 400; /* font-normal */
  line-height: 1.5; /* leading-normal */
  display: flex;
  gap: 0.75rem; /* gap-3 (12px) */
  color: #fff; /* text-white */
`;

const CheckIcon = styled.div`
  color: #fff; /* text-white */
  flex-shrink: 0; /* Prevents icon from shrinking */

  svg {
    width: 20px; /* data-size="20px" */
    height: 20px; /* data-size="20px" */
    fill: currentColor;
  }
`;

// Bottom CTA Button
const BottomCTAWrapper = styled.div`
  display: flex;
  padding: 0.75rem 1rem; /* px-4 py-3 (16px horizontal, 12px vertical) */
`;

const BottomCTAButton = styled(SubscribeButton)`
  flex: 1; /* flex-1 */
  /* Reuses styles from SubscribeButton but adds flex: 1 for full width */
`;

// Footer Spacer
const FooterSpacer = styled.div`
  height: 1.25rem; /* h-5 (20px) */
  background-color: #131516; /* bg-[#131516] */
`;

// --- React Functional Component ---

const Pricing = ({setPrice, price, navigate }) => {
  const { setTeamCount, isAuthenticated} = useContext(PriceContext);
  const [modelTrigger, SetModelTrigger] = useState(false);

  const [cardPrice, setCardPrice] = useState(false);

  function checkAuth(){
    if(!isAuthenticated){
      
      SetModelTrigger(!modelTrigger)
      return false
    } else{
      return true
    }
  
  }


  function handleSubmit(price, number, moreCredits=false){
    console.log('this is it',price)
    setPrice(price)
    let numb = number
    setTeamCount(numb)
    let authCheck = checkAuth()
    if (authCheck){
      console.log(authCheck)
   
      if(price > 400){
        console.log('we see more')
        navigate('/payment')
        return
      }
      navigate('/teams')
    }
    else{
      return
    }
    
}


  return (
    <PageContainer>
   
      {/* Top Section */}
      <div>
        <HeaderBar>
          {/* Removed BackArrowIcon component */}
          <HeaderTitle>Pricing</HeaderTitle>
        </HeaderBar>

        <PricingGrid>
          {/* Basic Plan Card */}
          <ModalWrapper trigger={modelTrigger}/>




          {/* Pro Plan Card */}

{/* 

remove when retested
<PricingCard>
  <PlanHeader>
\    <PlanName>Single Day Game Pass</PlanName> 
    <PlanPrice>
      <PriceNumber>$2.25</PriceNumber>
      <PriceFrequency>one-time</PriceFrequency> 
    </PlanPrice>
  </PlanHeader>
  
  <SubscribeButton onClick={()=> {handleSubmit(225, 2)}}>
    <span>Get Today's Picks</span>
  </SubscribeButton>

  <FeatureList>
    <FeatureItem>
      <CheckIcon>...</CheckIcon>
      <strong>Any 2 Teams:</strong> Full roster PTS + AST + REB projections
    </FeatureItem>
    <FeatureItem>
      <CheckIcon>...</CheckIcon>
      Valid for today's matchups only (One-off payment)
    </FeatureItem>
    <FeatureItem>
      <CheckIcon>...</CheckIcon>
      20+ AI-powered ML predictions included
    </FeatureItem>
    <FeatureItem>
      <CheckIcon>...</CheckIcon>
      Transparent next-day accuracy tracking
    </FeatureItem>
  </FeatureList>
</PricingCard>


*/}







          {/* Pro Plan Card */}


          <PricingCard>s
            <PlanHeader>
              <PlanName>Basic</PlanName>
              <PlanPrice>
                <PriceNumber>$4</PriceNumber>
                <PriceFrequency>/once</PriceFrequency>
              </PlanPrice>
            </PlanHeader>
            <SubscribeButton onClick={()=> {handleSubmit(400, 3)}}><span>Subscribe</span></SubscribeButton>
            <FeatureList>
              <FeatureItem>
                <CheckIcon>
                  <svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" fill="currentColor" viewBox="0 0 256 256">
                    <path d="M229.66,77.66l-128,128a8,8,0,0,1-11.32,0l-56-56a8,8,0,0,1,11.32-11.32L96,188.69,218.34,66.34a8,8,0,0,1,11.32,11.32Z"></path>
                  </svg>
                </CheckIcon>
                Access to 3 teams predictions
              </FeatureItem>
        
            </FeatureList>
          </PricingCard>


{/**cats */}


<PricingCard>
  <PlanHeader>
    <PlanName>Pro</PlanName>
    <PlanPrice>
      <PriceNumber>$15</PriceNumber>
      <PriceFrequency>/5 days</PriceFrequency>
    </PlanPrice>
  </PlanHeader>
  
  <SubscribeButton onClick={() => { handleSubmit(1500, 5) }}>
    <span>Get Started</span>
  </SubscribeButton>

  <FeatureList>
    <FeatureItem>
      <CheckIcon>
        <svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" fill="currentColor" viewBox="0 0 256 256">
          <path d="M229.66,77.66l-128,128a8,8,0,0,1-11.32,0l-56-56a8,8,0,0,1,11.32-11.32L96,188.69,218.34,66.34a8,8,0,0,1,11.32,11.32Z"></path>
        </svg>
      </CheckIcon>
      <strong>All Teams:</strong> All predictions for teams playing during subscriptiion window
    </FeatureItem>
    
    <FeatureItem>
      <CheckIcon>
        <svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" fill="currentColor" viewBox="0 0 256 256">
          <path d="M229.66,77.66l-128,128a8,8,0,0,1-11.32,0l-56-56a8,8,0,0,1,11.32-11.32L96,188.69,218.34,66.34a8,8,0,0,1,11.32,11.32Z"></path>
        </svg>
      </CheckIcon>
      <strong>90% Savings:</strong> 150+ picks for less than $0.35/day
    </FeatureItem>


  </FeatureList>
</PricingCard> 




                    {/* <PricingCard>
            <PlanHeader>
              <PlanName>Credit Package</PlanName>
              <PlanPrice>
                <PriceNumber>6</PriceNumber>
                <PriceFrequency>/unlimited</PriceFrequency>
              </PlanPrice>
            </PlanHeader>
            <SubscribeButton onClick={()=> {
              handleSubmit(600,20, true)
              
              }}>< span>Subscribe</span></SubscribeButton>
            <FeatureList>
              <FeatureItem>
                <CheckIcon>
                  <svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" fill="currentColor" viewBox="0 0 256 256">
                    <path d="M229.66,77.66l-128,128a8,8,0,0,1-11.32,0l-56-56a8,8,0,0,1,11.32-11.32L96,188.69,218.34,66.34a8,8,0,0,1,11.32,11.32Z"></path>
                  </svg>
                </CheckIcon>
                Use across all teams
              </FeatureItem>
              <FeatureItem>
                <CheckIcon>
                  <svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" fill="currentColor" viewBox="0 0 256 256">
                    <path d="M229.66,77.66l-128,128a8,8,0,0,1-11.32,0l-56-56a8,8,0,0,1,11.32-11.32L96,188.69,218.34,66.34a8,8,0,0,1,11.32,11.32Z"></path>
                  </svg>
                </CheckIcon>
                20 ML predictions
              </FeatureItem>
            </FeatureList>
          </PricingCard> */}
        </PricingGrid>
      </div>

      {/* Bottom Section */}
      <div>
                 <Link to='/demo' style={{ textDecoration: 'none', color: 'inherit' }}>

        <BottomCTAWrapper>
          <BottomCTAButton><span>View Demo</span></BottomCTAButton>
        </BottomCTAWrapper>
        </Link>

        <FooterSpacer />
      </div>
    </PageContainer>







  );
};

export default Pricing;